import { render } from "./PlanillaConsulta.vue?vue&type=template&id=140a3434&scoped=true"
import script from "./PlanillaConsulta.vue?vue&type=script&lang=js"
export * from "./PlanillaConsulta.vue?vue&type=script&lang=js"

import "./PlanillaConsulta.vue?vue&type=style&index=0&id=140a3434&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140a3434"]])

export default __exports__